ceregoCommon.factory('V3MyMilestonesResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_my_milestones_path()
])
